"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreDivider = _interopRequireDefault(require("@vfuk/core-divider"));

var _coreMatchMedia = require("@vfuk/core-match-media");

var _coreThemes = require("@vfuk/core-themes");

var _coreBaseProps = require("@vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/Footer.style"));

var _Logo = _interopRequireDefault(require("./components/Logo"));

var _Social = _interopRequireDefault(require("./components/Social"));

var _MobileLinkList = _interopRequireDefault(require("./components/MobileLinkList"));

var _DesktopLinkList = _interopRequireDefault(require("./components/DesktopLinkList"));

var _PartnerInfo = _interopRequireDefault(require("./components/PartnerInfo"));

var _LegalLinks = _interopRequireDefault(require("./components/LegalLinks"));

var _CompanyInfo = _interopRequireDefault(require("./components/CompanyInfo"));

var _PartnerLinks = _interopRequireDefault(require("./components/PartnerLinks"));

var _Footer2 = _interopRequireDefault(require("./themes/Footer.theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Footer = function Footer(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      social = _ref.social,
      partnerLogo = _ref.partnerLogo,
      legalLinks = _ref.legalLinks,
      companyInfo = _ref.companyInfo,
      additionalInfo = _ref.additionalInfo,
      copyrightText = _ref.copyrightText,
      partnerLinks = _ref.partnerLinks,
      linkGroups = _ref.linkGroups,
      onInteractionClick = _ref.onInteractionClick,
      onLoad = _ref.onLoad,
      localTheme = _ref.localTheme,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      id = _ref.id,
      dataAttributes = _ref.dataAttributes;
  var componentName = 'Footer';
  var footerTheme = (0, _coreThemes.useLocalTheme)(componentName, _Footer2["default"], localTheme);
  var _footerTheme$appearan = footerTheme.appearance[appearance],
      inverseLogo = _footerTheme$appearan.inverseLogo,
      dividerAppearance = _footerTheme$appearan.dividerAppearance,
      inverseDivider = _footerTheme$appearan.inverseDivider,
      inverseText = _footerTheme$appearan.inverseText,
      inverseIcon = _footerTheme$appearan.inverseIcon;

  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
      mdAndBelow = _useBreakpoints.mdAndBelow;

  (0, _react.useEffect)(function () {
    if (onLoad) {
      onLoad();
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(Styled.Footer, _extends({
    id: id,
    "data-component-name": componentName,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    footerTheme: footerTheme,
    appearance: appearance
  }, dataAttributes), /*#__PURE__*/_react["default"].createElement(Styled.FooterContainer, null, /*#__PURE__*/_react["default"].createElement(Styled.IconsWrapper, null, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    inverse: inverseLogo,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'logo')
  }), social && /*#__PURE__*/_react["default"].createElement(_Social["default"], {
    social: social,
    onInteractionClick: onInteractionClick,
    inverse: inverseIcon,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'social')
  })), /*#__PURE__*/_react["default"].createElement(Styled.DividerWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreDivider["default"], {
    appearance: dividerAppearance,
    inverse: inverseDivider
  })), linkGroups && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mdAndBelow ? /*#__PURE__*/_react["default"].createElement(_MobileLinkList["default"], {
    linkGroups: linkGroups,
    onInteractionClick: onInteractionClick,
    footerTheme: footerTheme,
    appearance: appearance,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'mobile-link-list')
  }) : /*#__PURE__*/_react["default"].createElement(_DesktopLinkList["default"], {
    linkGroups: linkGroups,
    onInteractionClick: onInteractionClick,
    inverse: inverseText,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'desktop-link-list')
  })), partnerLogo && /*#__PURE__*/_react["default"].createElement(_PartnerInfo["default"], {
    partnerLogo: partnerLogo,
    footerTheme: footerTheme,
    appearance: appearance,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'partner-info')
  }), /*#__PURE__*/_react["default"].createElement(_LegalLinks["default"], {
    legalLinks: legalLinks,
    onInteractionClick: onInteractionClick,
    footerTheme: footerTheme,
    appearance: appearance,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'legal-links')
  }), /*#__PURE__*/_react["default"].createElement(_CompanyInfo["default"], {
    companyInfo: companyInfo,
    additionalInfo: additionalInfo,
    copyrightText: copyrightText,
    inverse: inverseText,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'company-info')
  }), partnerLinks && /*#__PURE__*/_react["default"].createElement(_PartnerLinks["default"], {
    partnerLinks: partnerLinks,
    onInteractionClick: onInteractionClick,
    footerTheme: footerTheme,
    appearance: appearance,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'partner-links')
  })));
};

Footer.displayName = "Footer";
var _default = Footer;
exports["default"] = _default;
//# sourceMappingURL=Footer.js.map